export default __webpack_public_path__ + "static/media/planta_69.00e5d976.png";